const NOTIFICATIONS = '@NOTIFICATIONS';

export const FETCH = `${NOTIFICATIONS}/FETCH`;
